import React, { forwardRef , useEffect, useRef , useImperativeHandle} from "react";
import { MapContainer, TileLayer , useMap} from 'react-leaflet'
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {useSharedLang} from '../../hooks/useSharedLang.js'

// Google Maps 風の波紋付き青丸アイコン
const pulsingIcon = L.divIcon({
  html: '<div class="icon-pulse"></div>',
  className: "",
  iconSize: [20, 20],
});

/**
 * マップに現在地を表示する ※子: マーカー管理
 */
const CurrentLocationMarker = forwardRef((props, ref) => {
  const map = useMap();
  const markerRef = useRef(null);

  useEffect(() => {
    // カスタム pane を作成（ツールチップより上に配置）
    if (!map.getPane("currentLocationPane")) {
      const pane = map.createPane("currentLocationPane");
      pane.style.zIndex = 1000; // leaflet-tooltip-pane (650) より上
      pane.style.pointerEvents = "none"; // 地図操作をブロックしない
    }
  }, [map]);

  // 親(Map) から呼べる関数を公開
  useImperativeHandle(ref, () => ({
    updatePosition(lat, lng) {
      const pos = [lat, lng];
      if (!markerRef.current) {
        markerRef.current = L.marker(pos, { 
          icon: pulsingIcon ,
          pane: "currentLocationPane", // 専用paneを指定
        }).addTo(map);
      } else {
        markerRef.current.setLatLng(pos);
      }
    },
    remove() {
      if (markerRef.current) {
        map.removeLayer(markerRef.current);
        markerRef.current = null;
      }
    }
  }));

  return null; // React上では描画しない（Leafletに直接描画）
});

// --- 親: Mapコンポーネント ---
const Map = forwardRef((props, ref) => {

    const markerRef = useRef();

    const { sharedLang } = useSharedLang();
    // 緯度軽度
    const position = [35.682202905614844, 139.7553577646613];

    // 表示可能範囲 ※ 左上：右下 の [ 緯度, 経度 ]
    const bounds = [[35.70039284731116, 139.73890408873555], [35.668690303517626, 139.76850394159555]];

    // 親（画面コンポーネント）に公開する関数
    useImperativeHandle(ref, () => ({
      //現在地のマーカーを更新
      updateMarker(lat, lng) {
        markerRef.current.updatePosition(lat, lng);
      },
      clearMarker() {
        markerRef.current.remove();
      },
      // defaultPosition(){
      //   markerRef.current.updatePosition(position[0], position[1]);
      // }
    }));

    // 初期マップズームレベル
    const zoom = 14;
    return (
      <MapContainer 
        center={position} 
        zoom={zoom}
        zoomControl={false}
        scrollWheelZoom={false}
        minZoom={14}
        maxZoom={18}
        maxBounds={bounds}
        attributionControl={false}
    >
        <TileLayer
          attribution="Tiles © Esri — Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          opacity="0.2"
        />
        <TileLayer
          attribution=''
          url={`/assets/images/mapTiles/${sharedLang}/{z}/{x}_{y}.png`}
          opacity="1.0"
        />
        <CurrentLocationMarker ref={markerRef} />
        {props.children}
      </MapContainer>
    )
});
export default Map